import { BaseRequest } from "./baseRequest";
import { SearchCommand, SavedSearchCommand } from "./commands";

export class SearchDataRequest extends BaseRequest {
    
  search?: SearchCommand
  savedSearch?: SavedSearchCommand
}